import { Box } from '@locus-taxy/disco-ui';
import type { ReactNode } from 'react';

interface RouteWrapperProps {
  children: ReactNode;
}

export default function RouteWrapper({
  children,
}: Readonly<RouteWrapperProps>) {
  return (
    <Box className="flex h-full min-h-0 flex-grow flex-col overflow-hidden">
      {children}
    </Box>
  );
}
